module.exports = "/images/cover-pattern.png?c3437d3371f119024def49ac75d53fe4";